export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/piano-icon.svg?e906b53e9b6537dc04156bf3f7a977c7";